<template>
  <div>
    <div class="d-flex align-center flex-wrap mb-4">
      <v-chip
        v-for="language in languages"
        :key="language.code"
        :color="language.code === target ? 'primary' : ''"
        :outlined="language.code !== target"
        class="me-2 mb-1"
        small
        @click="target = language.code"
      >
        {{ language.name }}
        <v-icon
          v-if="filled(language.code)"
          right
          small
        >
          {{ icons.mdiCheck }}
        </v-icon>
      </v-chip>
    </div>

    <v-row>
      <v-col
        v-if="!isDefault"
        cols="12"
        md="6"
      >
        <div class="text--secondary text-caption mb-2">
          Русский · оригинал
        </div>
        <template v-for="field in fields">
          <div
            v-if="field.rich"
            :key="`ru-${field.key}`"
            class="translation-original mb-5"
          >
            <div class="text--secondary text-caption mb-1">
              {{ field.label }}
            </div>
            <!-- eslint-disable-next-line vue/no-v-html -->
            <div
              class="translation-original_body"
              v-html="text(defaultLanguage, field.key)"
            ></div>
          </div>
          <v-textarea
            v-else-if="field.multiline"
            :key="`ru-${field.key}`"
            :value="text(defaultLanguage, field.key)"
            :label="field.label"
            dense
            outlined
            readonly
            filled
          ></v-textarea>
          <v-text-field
            v-else
            :key="`ru-${field.key}`"
            :value="text(defaultLanguage, field.key)"
            :label="field.label"
            dense
            outlined
            readonly
            filled
          ></v-text-field>
        </template>
      </v-col>

      <v-col
        cols="12"
        :md="isDefault ? 12 : 6"
      >
        <div
          v-if="!isDefault"
          class="text--secondary text-caption mb-2"
        >
          {{ targetName }} · перевод
        </div>
        <template v-for="field in fields">
          <div
            v-if="field.rich"
            :key="`${target}-${field.key}`"
            class="mb-2"
          >
            <div class="text--secondary text-caption mb-1">
              {{ field.label }}
            </div>
            <tip-tap
              :value="text(target, field.key)"
              @input="write(field.key, $event)"
            ></tip-tap>
          </div>
          <v-textarea
            v-else-if="field.multiline"
            :key="`${target}-${field.key}`"
            :value="text(target, field.key)"
            :label="field.label"
            dense
            outlined
            @input="write(field.key, $event)"
          ></v-textarea>
          <v-text-field
            v-else
            :key="`${target}-${field.key}`"
            :value="text(target, field.key)"
            :label="field.label"
            :rules="field.required && isDefault ? [rules.required] : []"
            dense
            outlined
            @input="write(field.key, $event)"
          ></v-text-field>
        </template>
      </v-col>
    </v-row>

    <div class="text--secondary text-caption">
      Незаполненный язык не сохраняется — гость увидит русский.
    </div>
  </div>
</template>

<script>
import { mdiCheck } from '@mdi/js'
import { mapActions, mapState } from 'vuex'
import { rules } from '@/helpers/validation'
import TipTap from '@/components/tip-tap'

export default {
  name: 'TranslationFields',
  components: { TipTap },

  props: {
    value: { type: Array, default: () => [] },
    fields: { type: Array, required: true },
  },

  data: () => ({
    target: '',
    rules,
    icons: { mdiCheck },
  }),

  computed: {
    ...mapState('dictionary', ['languages']),

    defaultLanguage() {
      return this.$store.getters['dictionary/defaultLanguage']
    },

    isDefault() {
      return this.target === this.defaultLanguage
    },

    targetName() {
      const language = this.languages.find(x => x.code === this.target)

      return language ? language.name : this.target
    },
  },

  watch: {
    defaultLanguage: {
      immediate: true,
      handler(value) {
        if (!this.target && value) {
          this.target = value
        }
      },
    },
  },

  created() {
    this.fetchLanguages()
  },

  methods: {
    ...mapActions('dictionary', ['fetchLanguages']),

    translation(code) {
      return this.value.find(x => x.language === code)
    },

    text(code, key) {
      const translation = this.translation(code)

      return translation ? translation[key] : ''
    },

    filled(code) {
      const translation = this.translation(code)
      if (!translation) return false

      return this.fields
        .filter(x => x.required)
        .every(x => !!(translation[x.key] || '').trim())
    },

    write(key, text) {
      const translations = this.value.map(x => (x.language === this.target ? { ...x, [key]: text } : x))

      if (!translations.some(x => x.language === this.target)) {
        translations.push({ language: this.target, [key]: text })
      }

      this.$emit('input', translations)
    },
  },
}
</script>

<style lang="scss" scoped>
.translation-original_body {
  border: 1px solid rgba(94, 86, 105, 0.22);
  border-radius: 6px;
  padding: 10px 12px;
  min-height: 96px;
  overflow-wrap: anywhere;

  ::v-deep p:last-child {
    margin-bottom: 0;
  }
}
</style>
